import Card from "@elsa-zku/lib/components/Card";
import Select from "@elsa-zku/lib/components/Select";
import * as React from "react";
import { selectBuilding, useBuildingsList, useSelectedBuildingId } from "src/store/buildings";
// import { selectGroup, useGroupsList, useSelectedGroupId } from "src/store/group";

import style from "./Header.scss";

type Props = {};

const Header: React.FC<Props> = (props) => {
  const {} = props;
  const buildingsList = useBuildingsList();
  const buildingId = useSelectedBuildingId();

  const optionsBuildings = React.useMemo(() => {
    return buildingsList
      ? buildingsList.map(b => ({ label: b.name, value: b.id }))
      : []
  }, [buildingsList]);

  // const groupId = useSelectedGroupId();
  // const groupsList = useGroupsList();
  // const optionsGroups = React.useMemo(() => {
  //   return groupsList
  //     ? groupsList.map(g => ({ label: g.name, value: g.id }))
  //     : []
  // }, [groupsList]);



  return (
    <div className={style.container}>
      <Card rawBody>
        <div className={style.cardWrapper}>
          <div className={style.card}>
            <Select label="Выбранный дом" options={optionsBuildings} value={buildingId} onChange={selectBuilding} />
          </div>
        </div>
      </Card>
    </div>
  );
};

export default React.memo(Header);
